import { Chip, ChipProps } from '@mui/material'
import { FC } from 'react'

import { B2CRegistryStatus } from '@/@types/b2c.types.ts'
import { EMPTY_VALUE } from '@/constants.ts'

interface B2CStateRendererProps {
  value: B2CRegistryStatus
}

const STATUS_COLORS: Record<B2CRegistryStatus, ChipProps['color']> = {
  WAIT_CONFIRM: 'warning',
  ACCEPTED: 'warning',
  PROCESSING: 'warning',
  COMPLETED: 'success',
  FAILED: 'error',
}

const STATUS_TITLES: Record<B2CRegistryStatus, string> = {
  WAIT_CONFIRM: 'Ожидает подтверждения',
  ACCEPTED: 'Принят',
  PROCESSING: 'В работе',
  COMPLETED: 'Загружен',
  FAILED: 'Ошибка загрузки',
}

export const B2CRegistryTableStatusRenderer: FC<B2CStateRendererProps> = ({ value }) => {
  return value ? (
    <Chip
      label={STATUS_TITLES[value]}
      color={STATUS_COLORS[value]}
      variant="filled"
      size="small"
      sx={{
        borderRadius: 2,
      }}
    />
  ) : (
    EMPTY_VALUE
  )
}
